import React from 'react'
import { Logotext } from './logotext'


export const Authsidebar = () => {
    return (
        <div className='md:flex md:flex-col col-span-2 md:col-span-1 h-fit md:h-full p-4'>

            <Logotext />
            <div className='my-auto'>
                <div className='hidden md:block'>

                </div>
            </div>
        </div>)
}
